(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-modal-recommendations-loader"] && !Shopify.designMode) return;
  try {
    class SmartCartRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded === 'true') return;
      this.dataset.loaded = 'true';

      queueMicrotask(() => {
        if (!this.isConnected) return;

        this.load()
          .then((recommendations) => {
            if (recommendations) this.replaceWith(recommendations);
            else this.remove();
          })
          .catch(() => this.remove());
      });
    }

    normalize(value) {
      return String(value || '')
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
    }

    list(value) {
      return Array.isArray(value) ? value : [];
    }

    containsAny(value, terms) {
      const haystack = this.normalize(value);
      return this.list(terms).some((term) => haystack.includes(this.normalize(term)));
    }

    matchesRule(item, rule) {
      const productType = this.normalize(item.productType);
      const tags = this.list(item.tags).map((tag) => this.normalize(tag));
      const title = this.normalize(item.title);
      const allSourceText = [productType, title, ...tags].join(' ');

      if (this.containsAny(allSourceText, rule.sourceExcludeTerms)) return false;

      const typeMatch = this.list(rule.sourceProductTypes)
        .map((value) => this.normalize(value))
        .includes(productType);
      const tagMatch = this.list(rule.sourceTags)
        .map((value) => this.normalize(value))
        .some((value) => tags.includes(value));
      const titleMatch = this.containsAny(title, rule.sourceTitleTerms);

      return typeMatch || tagMatch || titleMatch;
    }

    buildRuleTasks(cartItems, rules) {
      const selectedRules = [];
      const selectedHandles = new Set();
      const orderedRules = this.list(rules)
        .filter((rule) => this.list(rule.targetQueries).length > 0)
        .sort((left, right) => Number(right.priority || 0) - Number(left.priority || 0));

      this.list(cartItems).forEach((item) => {
        const rule = orderedRules.find((candidate) => this.matchesRule(item, candidate));
        if (!rule || selectedHandles.has(rule.handle)) return;
        selectedHandles.add(rule.handle);
        selectedRules.push(rule);
      });

      const tasks = [];
      const maxTargets = Math.max(0, ...selectedRules.map((rule) => this.list(rule.targetQueries).length));

      for (let targetIndex = 0; targetIndex < maxTargets; targetIndex += 1) {
        selectedRules.forEach((rule) => {
          const query = this.list(rule.targetQueries)[targetIndex];
          if (query && tasks.length < 6) {
            tasks.push({ kind: 'rule', mode: 'search', query, rule });
          }
        });
      }

      return tasks;
    }

    isUtilityCollection(handle) {
      return [
        'all-products',
        'chatgpt',
        'best-selling',
        'nyhet',
        'kampanj',
        'sommarkampanj',
        'varumarken',
        'handla-efter',
        'mecenat',
        'alla-hjartans',
        'jul',
        'sale',
        'rea'
      ].some((term) => this.normalize(handle).includes(this.normalize(term)));
    }

    isBroadCollection(handle) {
      return [
        'halsa-valmaende',
        'skonhet-hygien',
        'livsmedel',
        'kosttillskott',
        'hjalpmedel',
        'till-hemmet',
        'hudvard',
        'traning',
        'klader',
        'allmant-valmaende'
      ].includes(this.normalize(handle).replaceAll(' ', '-'));
    }

    titleSearchTerms(item) {
      const vendorTerms = new Set(this.normalize(item.vendor).split(' ').filter(Boolean));
      const typeTerms = new Set(this.normalize(item.productType).split(' ').filter(Boolean));
      const ignoredTerms = new Set([
        'och', 'med', 'for', 'fran', 'utan', 'the', 'and', 'with',
        'kapslar', 'kapsel', 'tabletter', 'tablett', 'portioner',
        'pulver', 'pack', 'stycken', 'svart', 'svarta', 'vit', 'vita',
        'original', 'natural', 'naturell', 'ekologisk', 'organic'
      ]);

      return [...new Set(this.normalize(item.title).split(' '))]
        .filter((term) =>
          term.length >= 5 &&
          !/\d/.test(term) &&
          !vendorTerms.has(term) &&
          !typeTerms.has(term) &&
          !ignoredTerms.has(term)
        )
        .sort((left, right) => right.length - left.length)
        .slice(0, 2);
    }

    buildFallbackTasks(cartItems) {
      const tasksByItem = this.list(cartItems).map((item) => {
        const collections = this.list(item.collections)
          .filter((collection) =>
            collection?.handle &&
            !this.isUtilityCollection(collection.handle)
          )
          .sort((left, right) => {
            const leftBroad = this.isBroadCollection(left.handle) ? 1 : 0;
            const rightBroad = this.isBroadCollection(right.handle) ? 1 : 0;
            if (leftBroad !== rightBroad) return leftBroad - rightBroad;
            return String(right.handle).length - String(left.handle).length;
          });
        const specificCollections = collections.filter(
          (collection) => !this.isBroadCollection(collection.handle)
        );
        const broadCollections = collections.filter(
          (collection) => this.isBroadCollection(collection.handle)
        );
        const titleTerms = this.titleSearchTerms(item);
        const sourceContext = {
          productType: item.productType,
          vendor: item.vendor,
          titleTerms
        };
        const itemTasks = titleTerms.map((term) => ({
          kind: 'fallback',
          mode: 'title',
          query: term,
          titleTerm: term,
          ...sourceContext
        }));

        specificCollections.slice(0, 3).forEach((collection) => itemTasks.push({
          kind: 'fallback',
          mode: 'collection',
          collectionHandle: collection.handle,
          ...sourceContext
        }));

        if (item.vendor) {
          itemTasks.push({
            kind: 'fallback',
            mode: 'vendor',
            query: item.vendor,
            ...sourceContext
          });
        }

        if (item.productType) {
          itemTasks.push({
            kind: 'fallback',
            mode: 'type',
            query: item.productType,
            ...sourceContext
          });
        }

        broadCollections.slice(0, 2).forEach((collection) => {
          itemTasks.push({
            kind: 'fallback',
            mode: 'collection',
            collectionHandle: collection.handle,
            ...sourceContext
          });
        });

        return itemTasks;
      });
      const tasks = [];
      const seen = new Set();
      const maxTasksPerItem = Math.max(0, ...tasksByItem.map((itemTasks) => itemTasks.length));

      for (let taskIndex = 0; taskIndex < maxTasksPerItem; taskIndex += 1) {
        tasksByItem.forEach((itemTasks) => {
          const task = itemTasks[taskIndex];
          if (!task || tasks.length >= 12) return;
          const key = [
            task.mode,
            task.collectionHandle,
            task.titleTerm,
            task.productType,
            task.vendor,
            task.query
          ].filter(Boolean).join(':');
          if (seen.has(key)) return;
          seen.add(key);
          tasks.push(task);
        });
      }

      return tasks;
    }

    async fetchCandidates(task) {
      const url = task.mode === 'collection'
        ? new URL(`/collections/${encodeURIComponent(task.collectionHandle)}`, window.location.origin)
        : new URL(window.routes?.search_url || '/search', window.location.origin);
      url.searchParams.set('section_id', 'cart-modal-keyword-recommendations');
      if (task.mode !== 'collection') {
        url.searchParams.set('q', task.query);
        url.searchParams.set('type', 'product');
      }

      const response = await fetch(url.toString());
      if (!response.ok) return null;

      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const container = parsed.querySelector('.cart-modal-keyword-recommendations');
      if (!container) return null;

      return {
        container,
        candidates: [...container.querySelectorAll('[data-cart-recommendation-candidate]')],
        task
      };
    }

    candidateData(candidate) {
      let tags = [];
      try {
        tags = JSON.parse(candidate.dataset.productTags || '[]');
      } catch {
        tags = [];
      }

      return {
        id: String(candidate.dataset.productId || ''),
        price: Number(candidate.dataset.productPrice || 0),
        productType: String(candidate.dataset.productType || ''),
        vendor: String(candidate.dataset.productVendor || ''),
        tags,
        text: [
          candidate.dataset.productTitle,
          candidate.dataset.productType,
          candidate.dataset.productVendor,
          ...tags
        ].join(' ')
      };
    }

    isSafeCandidate(candidate, task, cartProductIds, chosenProductIds) {
      const data = this.candidateData(candidate);
      if (!data.id || data.price <= 0) return false;
      if (cartProductIds.has(data.id) || chosenProductIds.has(data.id)) return false;
      if (this.containsAny(data.text, ['tester', 'beauty set', 'giftset', 'presentset'])) {
        return false;
      }

      if (task.kind === 'rule') {
        if (!this.containsAny(data.text, task.rule.targetMatchTerms)) return false;
        if (this.containsAny(data.text, task.rule.excludeTargetTerms)) return false;
      }

      if (
        task.mode === 'type' &&
        this.normalize(data.productType) !== this.normalize(task.productType)
      ) {
        return false;
      }

      if (
        task.mode === 'vendor' &&
        this.normalize(data.vendor) !== this.normalize(task.vendor)
      ) {
        return false;
      }

      if (task.mode === 'title') {
        if (!this.containsAny(data.text, [task.titleTerm])) return false;

        if (task.productType || task.vendor) {
          const sameType =
            task.productType &&
            this.normalize(data.productType) === this.normalize(task.productType);
          const sameVendor =
            task.vendor &&
            this.normalize(data.vendor) === this.normalize(task.vendor);
          if (!sameType && !sameVendor) return false;
        }
      }

      if (task.mode === 'collection' && (task.productType || task.vendor)) {
        const sameType =
          task.productType &&
          this.normalize(data.productType) === this.normalize(task.productType);
        const sameVendor =
          task.vendor &&
          this.normalize(data.vendor) === this.normalize(task.vendor);
        if (!sameType && !sameVendor) return false;
      }

      return true;
    }

    candidateScore(candidate, task) {
      const data = this.candidateData(candidate);
      let score = 0;

      if (
        task.vendor &&
        this.normalize(data.vendor) === this.normalize(task.vendor)
      ) {
        score += 100;
      }

      if (
        task.productType &&
        this.normalize(data.productType) === this.normalize(task.productType)
      ) {
        score += 50;
      }

      this.list(task.titleTerms).forEach((term) => {
        if (this.containsAny(data.text, [term])) score += 20;
      });

      return score;
    }

    addCandidates(result, cartProductIds, chosenProductIds, selected) {
      if (!result || selected.length === 2) return 0;
      const limit =
        result.task.kind === 'rule' || result.task.mode === 'title' ? 1 : 2;
      let added = 0;
      const candidates = [...result.candidates].sort(
        (left, right) =>
          this.candidateScore(right, result.task) -
          this.candidateScore(left, result.task)
      );

      for (const candidate of candidates) {
        if (selected.length === 2 || added === limit) break;
        if (!this.isSafeCandidate(candidate, result.task, cartProductIds, chosenProductIds)) {
          continue;
        }

        const productId = String(candidate.dataset.productId);
        chosenProductIds.add(productId);
        selected.push(candidate.cloneNode(true));
        added += 1;
      }

      return added;
    }

    async load() {
      const dataNode = this.querySelector('[data-smart-cart-recommendation-data]');
      if (!dataNode) return null;

      const config = JSON.parse(dataNode.textContent);
      const cartItems = this.list(config.cartItems);
      if (cartItems.length === 0) return null;

      const ruleTasks = this.buildRuleTasks(cartItems, config.rules);
      const fallbackTasks = this.buildFallbackTasks(cartItems);
      const cartProductIds = new Set(
        cartItems.map((item) => String(item.productId))
      );
      const chosenProductIds = new Set();
      const selected = [];
      let shell = null;
      let ruleSelections = 0;

      const ruleResults = await Promise.all(
        ruleTasks.map((task) => this.fetchCandidates(task))
      );
      for (const result of ruleResults) {
        if (!result || selected.length === 2) continue;
        if (!shell) shell = result.container;
        ruleSelections += this.addCandidates(
          result,
          cartProductIds,
          chosenProductIds,
          selected
        );
      }

      for (
        let fallbackIndex = 0;
        fallbackIndex < fallbackTasks.length && selected.length < 2;
        fallbackIndex += 4
      ) {
        const fallbackResults = await Promise.all(
          fallbackTasks
            .slice(fallbackIndex, fallbackIndex + 4)
            .map((task) => this.fetchCandidates(task))
        );

        for (const result of fallbackResults) {
          if (!result || selected.length === 2) continue;
          if (!shell) shell = result.container;
          this.addCandidates(
            result,
            cartProductIds,
            chosenProductIds,
            selected
          );
        }
      }

      if (!shell || selected.length === 0) return null;

      const grid = shell.querySelector('.grid-carousel');
      if (!grid) return null;
      grid.replaceChildren(...selected);

      if (ruleSelections === 0) {
        const heading = shell.querySelector('.heading');
        if (heading && this.dataset.fallbackHeading) {
          heading.textContent = this.dataset.fallbackHeading;
        }
      }

      if (selected.length === 1) {
        shell
          .querySelectorAll('button[id$="-product-carousel-prev"], button[id$="-product-carousel-next"]')
          .forEach((button) => button.remove());
        shell.querySelector('scroll-carousel')?.removeAttribute('button-prev');
        shell.querySelector('scroll-carousel')?.removeAttribute('button-next');
      }

      return shell;
    }
  }

  if (!customElements.get('smart-cart-recommendations')) {
    customElements.define('smart-cart-recommendations', SmartCartRecommendations);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["halsovalet-chatbot"] && !Shopify.designMode) return;
  try {
    (() => {
    const normalize = (value) => value
      .normalize('NFD')
      .replace(/\p{Diacritic}/gu, '')
      .toLowerCase();

    const classify = (question) => {
      const value = normalize(question);
      if (/^(hej|hejsan|tjena|halla|hello|hi|hey|hallo|hola|bonjour|salut|ciao|buongiorno|hoi|goedendag)[!.? ]*$/.test(value)) return 'greeting';
      if (/(gravid|ammar|lakemedel|medicin|diagnos|sjukdom|allerg|biverk|dosering|symtom|blodtryck|diabet|recept|pregnan|breastfeed|medication|disease|side effect|schwanger|stillen|krankheit|nebenwirkung|embaraz|lactancia|enfermedad|efecto secundario|enceinte|allait|maladie|effet secondaire|gravidanza|allatt|farmaco|malattia|effetto collaterale|zwanger|borstvoeding|medicijn|ziekte|bijwerking)/.test(value)) return 'medical';
      if (/(retur|returnera|anger|reklamation|skadad|trasig|oppnad forpackning|return|refund|damaged|ruckgabe|widerruf|beschadigt|devolucion|reembolso|danado|remboursement|endommage|reso|restituzione|rimborso|danneggiato|terugsturen|herroep)/.test(value)) return 'returns';
      if (/(orderstatus|ordernummer|min order|bestallning|sparning|spara paket|var ar mitt paket|inte kommit|my order|order number|tracking|bestellung|sendung|pedido|seguimiento|commande|suivi|ordine|tracciamento|bestelnummer|bestelling)/.test(value)) return 'order';
      if (/(frakt|porto|fri frakt|fraktkostnad|shipping cost|free shipping|versandkosten|kostenloser versand|gastos de envio|envio gratis|frais de port|livraison gratuite|costo di spedizione|spedizione gratuita|verzendkosten|gratis verzending)/.test(value)) return 'shipping';
      if (/(leverans|leveranstid|nar kommer|hur lang tid|skickas|delivery|delivery time|lieferzeit|lieferung|plazo de entrega|entrega|delai de livraison|livraison|tempo di consegna|consegna|levertijd|bezorging)/.test(value)) return 'delivery';
      if (/(kontakt|kundservice|mejl|mail|telefon|manniska|personal|contact|customer service|kundenservice|contacto|atencion al cliente|contacter|service client|contatto|servizio clienti|klantenservice)/.test(value)) return 'contact';
      if (/(produkt|vitamin|protein|magnesium|kosttillskott|hudvard|schampo|traning|aterhamtning|somn|energi|halsa|skonhet|hygien|kreatin|omega|product|supplement|skincare|produkt|nahrungserganz|producto|suplemento|produit|complement|prodotto|integratore|voedingssupplement)/.test(value)) return 'product';
      return 'fallback';
    };

    const runTransition = (callback) => {
      callback();
      return Promise.resolve();
    };

    document.querySelectorAll('[data-hv-chatbot]').forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const launcher = root.querySelector('[data-hv-chatbot-open]');
      const dialog = root.querySelector('[data-hv-chatbot-dialog]');
      const closeButton = root.querySelector('[data-hv-chatbot-close]');
      const messages = root.querySelector('[data-hv-chatbot-messages]');
      const form = root.querySelector('[data-hv-chatbot-form]');
      const input = root.querySelector('[data-hv-chatbot-input]');
      const submitButton = form.querySelector('button[type="submit"]');
      const quickButtons = [...root.querySelectorAll('[data-hv-chatbot-intent]')];
      const conversation = [];
      let busy = false;

      const definitions = {
        greeting: {
          text: root.dataset.responseGreeting,
        },
        product: {
          text: root.dataset.responseProduct,
          label: root.dataset.linkProducts,
          url: root.dataset.productsUrl,
        },
        delivery: {
          text: root.dataset.responseDelivery,
          label: root.dataset.linkShipping,
          url: root.dataset.shippingUrl,
        },
        shipping: {
          text: root.dataset.responseShipping,
          label: root.dataset.linkShipping,
          url: root.dataset.shippingUrl,
        },
        returns: {
          text: root.dataset.responseReturns,
          label: root.dataset.linkReturns,
          url: root.dataset.returnsUrl,
        },
        order: {
          text: root.dataset.responseOrder,
          label: root.dataset.linkAccount,
          url: root.dataset.accountUrl,
        },
        contact: {
          text: root.dataset.responseContact,
          label: root.dataset.linkContact,
          url: root.dataset.contactUrl,
        },
        medical: {
          text: root.dataset.responseMedical,
          label: root.dataset.linkContact,
          url: root.dataset.contactUrl,
        },
        fallback: {
          text: root.dataset.responseFallback,
          label: root.dataset.linkContact,
          url: root.dataset.contactUrl,
        },
      };

      const addMessage = (speaker, text, link, products = []) => {
        const message = document.createElement('div');
        message.className = `hv-chatbot__message hv-chatbot__message--${speaker}`;

        const label = document.createElement('span');
        label.className = 'hv-chatbot__sr-only';
        label.textContent = `${speaker === 'bot' ? root.dataset.assistantName : root.dataset.youLabel}:`;
        message.append(label);

        const content = document.createElement('span');
        content.textContent = text;
        message.append(content);

        if (link?.url && link?.label) {
          const anchor = document.createElement('a');
          anchor.href = link.url;
          anchor.textContent = `${link.label} →`;
          message.append(document.createElement('br'), anchor);
        }

        if (speaker === 'bot' && Array.isArray(products) && products.length) {
          const productLinks = document.createElement('div');
          productLinks.className = 'hv-chatbot__product-links';

          products.slice(0, 3).forEach((product) => {
            if (!product || typeof product.title !== 'string' || typeof product.url !== 'string') return;
            let target;
            try {
              target = new URL(product.url, window.location.origin);
            } catch (_error) {
              return;
            }
            if (target.origin !== window.location.origin || !target.pathname.startsWith('/products/')) return;

            const productLink = document.createElement('a');
            productLink.className = 'hv-chatbot__product-link';
            productLink.href = `${target.pathname}${target.search}`;

            const productTitle = document.createElement('span');
            productTitle.className = 'hv-chatbot__product-title';
            productTitle.textContent = product.title.trim();
            productLink.append(productTitle);

            if (typeof product.price === 'string' && product.price.trim()) {
              const productPrice = document.createElement('span');
              productPrice.className = 'hv-chatbot__product-price';
              productPrice.textContent = product.price.trim();
              productLink.append(productPrice);
            }

            productLinks.append(productLink);
          });

          if (productLinks.childElementCount) message.append(productLinks);
        }

        messages.append(message);
        messages.scrollTop = messages.scrollHeight;
        return message;
      };

      const respond = (intent, question = '') => {
        const definition = definitions[intent] || definitions.fallback;
        const link = { label: definition.label, url: definition.url };

        if (intent === 'product' && question) {
          link.label = root.dataset.linkSearch;
          link.url = `${root.dataset.searchUrl}?q=${encodeURIComponent(question)}&type=product`;
        }

        addMessage('bot', definition.text, link);
        conversation.push({ role: 'assistant', content: definition.text });
      };

      const setBusy = (value) => {
        busy = value;
        input.disabled = value;
        submitButton.disabled = value;
        quickButtons.forEach((button) => { button.disabled = value; });
        form.setAttribute('aria-busy', value ? 'true' : 'false');
      };

      const askAi = async () => {
        const apiUrl = root.dataset.apiUrl?.trim();
        if (!apiUrl) return false;

        setBusy(true);
        const typing = addMessage('bot', root.dataset.aiThinking);
        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), 15000);

        try {
          const response = await fetch(apiUrl, {
            method: 'POST',
            mode: 'cors',
            credentials: 'omit',
            referrerPolicy: 'strict-origin-when-cross-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              messages: conversation.slice(-10),
              locale: document.documentElement.lang || 'sv',
              pagePath: window.location.pathname,
            }),
            signal: controller.signal,
          });
          const payload = await response.json().catch(() => ({}));
          if (!response.ok || typeof payload.reply !== 'string' || !payload.reply.trim()) return false;

          const reply = payload.reply.trim();
          typing.remove();
          addMessage('bot', reply, null, payload.products);
          conversation.push({ role: 'assistant', content: reply });
          return true;
        } catch (_error) {
          return false;
        } finally {
          window.clearTimeout(timeout);
          if (typing.isConnected) typing.remove();
          setBusy(false);
        }
      };

      const open = () => {
        if (dialog.open) return;
        runTransition(() => {
          if (typeof dialog.show === 'function') dialog.show();
          else dialog.setAttribute('open', '');
          launcher.setAttribute('aria-expanded', 'true');
        }).then(() => input.focus());
      };

      const close = () => {
        if (!dialog.open) return;
        runTransition(() => {
          if (typeof dialog.close === 'function') dialog.close();
          else dialog.removeAttribute('open');
          launcher.setAttribute('aria-expanded', 'false');
        }).then(() => launcher.focus());
      };

      launcher.addEventListener('click', open);
      closeButton.addEventListener('click', close);
      dialog.addEventListener('close', () => launcher.setAttribute('aria-expanded', 'false'));

      dialog.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          close();
        }
      });

      quickButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (busy) return;
          const question = button.textContent.trim();
          addMessage('user', question);
          conversation.push({ role: 'user', content: question });
          respond(button.dataset.hvChatbotIntent);
        });
      });

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (busy) return;
        const question = input.value.trim().replace(/\s+/g, ' ');
        if (!question) return;
        addMessage('user', question);
        conversation.push({ role: 'user', content: question });
        input.value = '';
        const answeredByAi = await askAi();
        if (!answeredByAi) respond(classify(question), question);
        input.focus();
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hv-price-compare"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hv-price-compare')) {
    customElements.define('hv-price-compare', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const form = this.querySelector('form');
        const output = form.querySelector('output');
        const mode = form.elements.mode;
        const inputs = [...form.querySelectorAll('input')];
        const clear = () => { output.textContent = this.dataset.empty; inputs.forEach(input => input.removeAttribute('aria-invalid')); };
        const labels = () => form.querySelectorAll('[data-quantity-label]').forEach(label => label.textContent = mode.selectedOptions[0].dataset.quantity);
        const parse = value => {
          const text = value.trim();
          return /^\d+(?:[.,]\d+)?$/.test(text) ? Number(text.replace(',', '.')) : NaN;
        };
        form.hidden = false;
        form.addEventListener('submit', event => {
          event.preventDefault();
          const values = inputs.map(input => parse(input.value));
          const invalid = values.findIndex(value => !Number.isFinite(value) || value <= 0 || value > 1000000000);
          inputs.forEach((input, i) => input.setAttribute('aria-invalid', String(!Number.isFinite(values[i]) || values[i] <= 0 || values[i] > 1000000000)));
          if (invalid !== -1) { output.textContent = this.dataset.invalid; inputs[invalid].focus(); return; }
          const factor = mode.value === 'portion' ? 1 : 100;
          const a = values[0] / values[1] * factor;
          const b = values[2] / values[3] * factor;
          const money = new Intl.NumberFormat('sv-SE', { style: 'currency', currency: 'SEK', minimumFractionDigits: 2, maximumFractionDigits: 2 });
          const unit = mode.selectedOptions[0].dataset.unit;
          const same = Math.round(a * 100) === Math.round(b * 100);
          const winner = a < b ? this.dataset.a : this.dataset.b;
          output.textContent = `${this.dataset.a}: ${money.format(a)} ${unit}\n${this.dataset.b}: ${money.format(b)} ${unit}\n${same ? this.dataset.equal : winner + ' ' + this.dataset.lower}`;
        });
        form.addEventListener('input', clear);
        mode.addEventListener('change', () => { inputs.filter(input => input.name.startsWith('quantity')).forEach(input => { input.value = ''; }); labels(); clear(); });
        form.addEventListener('reset', event => {
          event.preventDefault();
          inputs.forEach(input => { input.value = ''; });
          mode.selectedIndex = 0;
          labels();
          clear();
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hv-product-compare"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hv-product-compare')) {
    customElements.define('hv-product-compare', class extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;
        this.labels = JSON.parse(this.querySelector('[data-compare-labels]').textContent);
        this.items = [null, null];
        this.cache = new Map();
        this.storageKey = 'hv-product-comparison-v1';
        this.form = this.querySelector('form');
        this.input = this.form.querySelector('input');
        this.results = this.querySelector('.hv-auto__results');
        this.status = this.querySelector('[role="status"]');
        this.cards = this.querySelector('.hv-auto__cards');
        this.comparison = this.querySelector('.hv-auto__comparison');
        this.clearButton = this.querySelector('[data-clear]');
        this.querySelector('[data-interactive]').hidden = false;
        this.form.addEventListener('submit', event => { event.preventDefault(); clearTimeout(this.timer); this.search(); });
        this.input.addEventListener('input', () => {
          clearTimeout(this.timer);
          this.searchController?.abort();
          this.results.hidden = true;
          if (this.input.value.trim().length < 2) { this.message('select_two'); return; }
          this.timer = setTimeout(() => this.search(), 300);
        });
        this.input.addEventListener('keydown', event => {
          if (event.key === 'Escape') { this.searchController?.abort(); this.results.hidden = true; }
          if (event.key === 'ArrowDown' && !this.results.hidden) { event.preventDefault(); this.results.querySelector('button')?.focus(); }
        });
        this.results.addEventListener('keydown', event => { if(event.key === 'Escape') { this.results.hidden = true; this.input.focus(); } });
        this.clearButton.addEventListener('click', () => { if(this.busy) return; this.items = [null,null]; this.save(); this.render(); this.message('select_two'); this.input.focus(); });
        this.render();
        this.restore();
      }
      disconnectedCallback() { clearTimeout(this.timer); this.searchController?.abort(); }
      element(tag, className, text) {
        const element = document.createElement(tag);
        if (className) element.className = className;
        if (text != null) element.textContent = text;
        return element;
      }
      message(key) { this.status.textContent = this.labels[key]; }
      async request(url, signal) {
        const timeout = AbortSignal.timeout(12000);
        const response = await fetch(url, { credentials: 'same-origin', signal: signal ? AbortSignal.any([signal,timeout]) : timeout });
        if (!response.ok) throw new Error('Comparison request failed');
        return response;
      }
      async search() {
        const query = this.input.value.trim();
        if (this.busy || query.length < 2 || this.items.every(Boolean)) return;
        this.searchController?.abort();
        const controller = new AbortController();
        this.searchController = controller;
        this.message('searching');
        const url = new URL(this.dataset.search + '.json', location.origin);
        url.search = new URLSearchParams({q:query,'resources[type]':'product','resources[limit]':'8','resources[options][unavailable_products]':'last'});
        try {
          const response = await this.request(url, controller.signal);
          const data = await response.json();
          if (controller.signal.aborted || query !== this.input.value.trim() || !this.isConnected) return;
          const products = data?.resources?.results?.products;
          if (!Array.isArray(products)) throw new Error('Invalid product search');
          this.results.replaceChildren();
          for (const product of products) {
            if (!/^[a-z0-9][a-z0-9-]*$/.test(product.handle) || !product.title) continue;
            const li = this.element('li');
            const button = this.element('button');
            button.type = 'button';
            button.setAttribute('aria-label', this.labels.add + ': ' + product.title);
            const name = this.element('span','hv-auto__result-name',product.title);
            name.append(this.element('small','',product.vendor || ''));
            button.append(name,this.element('span','hv-auto__result-add',this.labels.add + ' +'));
            const selected = this.items.some(item => item?.handle === product.handle);
            button.disabled = selected;
            if (selected) button.setAttribute('aria-label',product.title + ': ' + this.labels.duplicate);
            button.addEventListener('click', () => this.add(product.handle));
            li.append(button); this.results.append(li);
          }
          this.results.hidden = !this.results.children.length;
          this.message(this.results.hidden ? 'no_results' : 'found');
        } catch (error) {
          if (!controller.signal.aborted && this.isConnected) { this.results.hidden = true; this.message('error'); }
        }
      }
      async load(handle, variant) {
        if (!/^[a-z0-9][a-z0-9-]*$/.test(handle)) throw new Error('Invalid handle');
        let product = this.cache.get(handle);
        if (!product) {
          const url = new URL(this.dataset.root + 'products/' + encodeURIComponent(handle),location.origin);
          url.searchParams.set('section_id','hv-comparison-data');
          const response = await this.request(url);
          const documentFragment = new DOMParser().parseFromString(await response.text(),'text/html');
          const json = documentFragment.querySelector('[data-hv-comparison-data]');
          if (!json) throw new Error('Product data not available');
          product = JSON.parse(json.textContent);
          if (product.handle !== handle || !Array.isArray(product.variants) || !product.variants.length) throw new Error('Invalid product data');
          for (const key of ['description','ingredients','nutrition','usage','specifications']) {
            const decoder = document.createElement('textarea');
            decoder.innerHTML = String(product[key] || '').replace(/</g,'&lt;').replace(/>/g,'&gt;');
            product[key] = decoder.value.replace(/\u00a0/g,' ').replace(/\r\n?/g,'\n').replace(/\n[ \t]+\n/g,'\n\n').replace(/\n{3,}/g,'\n\n').trim();
          }
          this.cache.set(handle,product);
        }
        return {...product, selectedVariant: product.variants.some(item=>item.id===variant) ? variant : product.defaultVariant};
      }
      async add(handle) {
        if (this.busy) return;
        if (this.items.some(item=>item?.handle===handle)) { this.message('duplicate'); return; }
        const slot = this.items.findIndex(item=>!item);
        if (slot < 0) { this.message('full'); return; }
        this.busy = true; this.setBusy(true); this.message('loading');
        this.searchController?.abort(); clearTimeout(this.timer);
        this.results.hidden = true;
        try {
          const product = await this.load(handle);
          if (!this.isConnected) return;
          this.items[slot] = product;
          this.input.value = '';
          this.save(); this.render();
          this.message(this.items.every(Boolean) ? 'selected_two' : 'selected_one');
          if(this.items.every(Boolean)) this.cards.querySelector('h3')?.focus(); else this.input.focus();
        } catch { this.message('error'); }
        finally { this.busy = false; this.setBusy(false); }
      }
      setBusy(value) {
        this.setAttribute('aria-busy',String(value));
        this.form.querySelector('button').disabled = value;
        this.input.disabled = value;
        this.clearButton.disabled = value;
      }
      save() {
        try { sessionStorage.setItem(this.storageKey,JSON.stringify(this.items.map(item=>item ? {handle:item.handle,variant:item.selectedVariant} : null))); } catch { /* Comparison still works if browser storage is unavailable. */ }
      }
      async restore() {
        let saved = [];
        try { const value = JSON.parse(sessionStorage.getItem(this.storageKey)); if (Array.isArray(value)) saved=value.slice(0,2); } catch { /* Start empty. */ }
        const current = this.dataset.current;
        if (current) saved = [{handle:current,variant:this.dataset.currentVariant},saved.find(item=>item?.handle && item.handle!==current) || null];
        if (!saved.some(item=>item?.handle)) return;
        this.busy = true; this.setBusy(true); this.message('loading');
        const seen = new Set();
        let failed = false;
        for (let i=0; i<2; i++) {
          const item = saved[i];
          if (!item?.handle || seen.has(item.handle)) continue;
          seen.add(item.handle);
          try { this.items[i] = await this.load(item.handle,item.variant); } catch { failed=true; }
        }
        if (!this.isConnected) return;
        this.busy = false; this.setBusy(false); this.save(); this.render();
        this.message(failed ? 'error' : this.items.every(Boolean) ? 'selected_two' : 'selected_one');
      }
      selected(item) { return item.variants.find(variant=>variant.id===item.selectedVariant) || item.variants[0]; }
      productUrl(item) { return this.dataset.root + 'products/' + encodeURIComponent(item.handle) + '?variant=' + encodeURIComponent(item.selectedVariant); }
      render() {
        const filled = this.items.filter(Boolean).length;
        this.form.hidden = filled === 2;
        this.clearButton.hidden = filled === 0;
        this.cards.replaceChildren();
        this.items.forEach((item,index) => {
          const card = this.element('article','hv-auto__card' + (item ? '' : ' hv-auto__card--empty'));
          if (!item) {
            const plus = this.element('span','hv-auto__empty-symbol','+'); plus.setAttribute('aria-hidden','true');
            const choose = this.element('button','',this.labels.choose); choose.type='button';
            choose.addEventListener('click',()=>this.input.focus());
            card.append(plus,this.element('h3','',this.labels[index===0 ? 'empty_a' : 'empty_b']),choose);
          } else {
            const variant = this.selected(item);
            if (item.image) { const img=this.element('img');img.src=item.image;img.alt='';img.width=110;img.height=110;card.append(img); }
            const title=this.element('h3','',item.title); title.tabIndex=-1;
            card.append(this.element('span','hv-auto__card-vendor',item.vendor),title,this.element('p','hv-auto__price',variant.price),this.element('span','hv-auto__stock',this.labels[variant.available ? 'available' : 'unavailable']));
            if(item.variants.length>1) {
              const label=this.element('label','',this.labels.variant);
              const select=this.element('select');
              select.id='Compare-variant-'+this.dataset.instance+'-'+index;
              label.htmlFor=select.id;
              item.variants.forEach(value=>{const option=this.element('option','',value.title);option.value=value.id;option.selected=value.id===item.selectedVariant;select.append(option);});
              select.addEventListener('change',()=>{item.selectedVariant=select.value;this.save();this.render();this.querySelector('#'+CSS.escape(select.id))?.focus();});
              label.append(select);card.append(label);
            }
            const actions=this.element('div','hv-auto__card-actions');
            const view=this.element('a','',this.labels.view);view.href=this.productUrl(item);
            const remove=this.element('button','',this.labels.remove);remove.type='button';remove.setAttribute('aria-label',this.labels.remove+': '+item.title);
            remove.addEventListener('click',()=>{if(this.busy)return;this.items[index]=null;this.save();this.render();this.message('selected_one');this.input.focus();});
            actions.append(view,remove);card.append(actions);
          }
          this.cards.append(card);
        });
        this.comparison.hidden = filled < 2;
        this.comparison.replaceChildren();
        if(filled<2) return;
        const fields=['vendor','unit_price','ingredients','nutrition','usage','description','specifications'];
        for(const key of fields) {
          if(key==='unit_price' && this.items.every(item=>!this.selected(item).unitPrice)) continue;
          if(key==='specifications' && this.items.every(item=>!item.specifications)) continue;
          const row=this.element('section','hv-auto__row');
          row.append(this.element('h3','hv-auto__row-heading',this.labels[key]));
          const values=this.element('div','hv-auto__row-values');
          let long=false;
          this.items.forEach(item=>{
            const text=key==='unit_price' ? this.selected(item).unitPrice : item[key];
            const cell=this.element('div','hv-auto__cell');
            cell.append(this.element('span','hv-auto__cell-name',item.title));
            const content=this.element('p','hv-auto__cell-text',String(text || '').trim() || this.labels.missing);
            if(String(text || '').length>300) long=true;
            cell.append(content); values.append(cell);
          });
          row.append(values);
          if(long) {
            values.querySelectorAll('.hv-auto__cell-text').forEach(element=>element.dataset.clamped='');
            const expand=this.element('button','hv-auto__expand',this.labels.more);expand.type='button';expand.setAttribute('aria-expanded','false');
            expand.addEventListener('click',()=>{const opening=expand.getAttribute('aria-expanded')==='false';expand.setAttribute('aria-expanded',String(opening));expand.textContent=this.labels[opening?'less':'more'];values.querySelectorAll('.hv-auto__cell-text').forEach(element=>{if(opening)delete element.dataset.clamped;else element.dataset.clamped='';});});
            row.append(expand);
          }
          this.comparison.append(row);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
